import EmptyState from "@components/common/EmptyState";
import { useNavigate } from "react-router-dom";
import { usePDF } from "@context/PDFContext";
import { useError } from "@context/ErrorContext";
export default function FormsTabProfile({ forms }) {
  const navigate = useNavigate();
  const { handleExportPDF } = usePDF();
  const { showError } = useError();

  const handleExport = async (fileId, title, date) => {
    try {
      await handleExportPDF(fileId, title, date, showError);
    } catch (error) {
      showError(`Error exporting PDF: ${error.message}`);
    }
  };

  if (!forms || forms.length === 0) {
    return (
      <div className="p-5">
        <EmptyState
          image="/Visuals - No forms filled in yet.svg"
          title="No form has been filled in yet."
          subtitle="Click 'Fill in New Form' to start a new form for this patient."
        />
      </div>
    );
  }
  return (
    <div className="space-y-6 p-4">
      {forms.map((group) => (
        <div key={group.date}>
          <h2 className="text-lg font-bold text-gray-900 mb-3">
            Visit {group.date}
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {group.files.map((file) => (
              <div
                key={file.file_id}
                className="border border-gray-300 rounded-lg p-4 flex items-start justify-between bg-white w-full max-w-md"
              >
                <div className="flex items-start gap-3">
                  <div className="mt-1">
                    <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-green-100 text-green-700">
                      <svg
                        className="w-6 h-6 text-green-700 dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fillRule="evenodd"
                          d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </div>

                  {/* Text block */}
                  <div className="space-y-2">
                    <p className=" text-black">{file.file_name}</p>
                    <p className="text-sm text-gray-600">Completed </p>

                    <button
                      onClick={()=>handleExport(file.file_id,file.file_name,group.date )}
                      className="inline-flex items-center gap-2 text-sm font-medium text-gray-900 border border-gray-300 px-5 py-2.5 rounded-md hover:bg-gray-100"
                    >
                      <svg
                        className="w-6 h-6 text-gray-900 dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fillRule="evenodd"
                          d="M13 11.15V4a1 1 0 1 0-2 0v7.15L8.78 8.374a1 1 0 1 0-1.56 1.25l4 5a1 1 0 0 0 1.56 0l4-5a1 1 0 1 0-1.56-1.25L13 11.15Z"
                          clipRule="evenodd"
                        />
                        <path
                          fillRule="evenodd"
                          d="M9.657 15.874 7.358 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2.358l-2.3 2.874a3 3 0 0 1-4.685 0ZM17 16a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Download
                    </button>
                  </div>
                </div>

                {/* Edit icon */}
                <button
                  onClick={() =>
                    navigate("/fill-form", {
                      state: {
                        id: file.file_id,
                        name:file.file_name,
                        formName: file.template_name,
                        content: file.file_content,
                        template_id: file.template_id,
                        patient_id: file.patient_id,
                      },
                    })
                  }
                  className="text-gray-500 hover:text-blue-600"
                  aria-label="Edit"
                >
                  <svg
                    className="w-6 h-6 text-gray-900 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
                    />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
